// @flow

import styled from 'styled-components';

export const List = styled.ol`
  list-style: none;
`;

export const ListItem = styled.li`
  line-height: 1.3em;
  min-height: 2.6em;
  counter-increment: list-counter;
  position: relative;

  &:nth-last-child(1)::before {
    content: none;
  }

  --size: 1.72em;

  padding: 0 0 1em calc(var(--size) + 1em);

  ::before {
    content: '';
    padding: 0.1em;
    height: calc(100% - var(--size) - 0.5em);
    position: absolute;
    left: calc(var(--size) / 2 - 0.16em);
    bottom: 0.25em;
    background-color: ${props => props.theme.colors.gray[1]};
  }

  ::after {
    content: counter(list-counter);

    background-color: ${props => props.theme.colors.gray[1]};

    font-family: ${props => props.theme.fontFamily.display};
    font-size: 0.86em;
    font-weight: bold;

    position: absolute;

    top: 0;
    left: 0;

    line-height: var(--size);
    width: var(--size);
    height: var(--size);

    border-radius: 50%;
    text-align: center;
  }
`;
